<template>
  <div>
    <div>
      <LoaderTuin :is-loading="loader" />
    </div>
    <div class="flex">
      <ToastAlert
        :is-active="toastAlert"
        :type="typeMsg"
        :message="msg"
      />
    </div>
    <!-- Precio -->
    <div v-if="!loader" :class="type_movement_id == 3 ? 'sm:w-[760px]' : 'sm:w-[380px]'">
      <div
        class="flex flex-col space-y-4"
      >
        <!-- Layout de tres filas con dos columnas para type_movement_id == 3 -->
        <p class="text-lg font-medium text-black">Precio</p>
        <div v-if="type_movement_id == 3" class="space-y-8">
          <!-- Primera fila: Price inputs -->
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <!-- Price input sale section -->
            <div class="flex flex-1 justify-center items-center">
              <div class="w-full">
                <PriceInput
                  label="Valor de venta *"
                  v-model="property_value"
                  :currency="currency"
                  :currency-options="currencyOptions"
                  input-id="currency-input"
                  placeholder="Ingresa el precio de venta"
                  :required="true"
                  dropdown-align="right"
                  @update:currency="selectCurrency"
                />
              </div>
              <hr class="h-px my-8 bg-gray-300 border-0">
            </div>
            <!-- Price input rent section-->
            <div class="flex flex-1 justify-center items-center">
              <div class="w-full">
                <PriceInput
                  label="Valor de renta *"
                  v-model="rent_value"
                  :currency="rentCurrency"
                  :currency-options="currencyOptions"
                  input-id="rent-currency-input"
                  placeholder="Ingresa el precio de renta"
                  :required="true"
                  dropdown-align="right"
                  @update:currency="selectRentCurrency"
                />
              </div>
            </div>
          </div>
          <hr class="h-px my-8 bg-gray-300 border-0">
          <!-- Segunda fila: Maintenance -->
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <!--Mantenance section-->
            <div v-if="![ 4, 6, 9 ].includes( type_property_id )" class="flex flex-col space-y-4">
              <div class="flex flex-1 justify-start items-start">
                <div class="flex flex-col w-full space-y-4">
                  <div class="flex items-center">
                    <input 
                      id="include-maintenance-checkbox" 
                      v-model="include_maintenance"
                      type="checkbox" 
                      class="w-4 h-4 text-tuin_base-0 bg-gray-100 border-gray-300 rounded focus:ring-transparent"
                    >
                    <label for="include-maintenance-checkbox" class="ms-2 text-sm font-medium text-custom_gray cursor-pointer">Incluye mantenimiento</label>
                  </div>

                  <div v-show="!include_maintenance" class="w-full">
                    <div class="w-full mt-[-1]">
                      <p class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">
                        Costo de mantenimiento *
                      </p>
                      <input
                        v-model="maintenance_value"
                        type="text"
                        id="maintenance_value"
                        placeholder="Ingresa el costo de mantenimiento"
                        class="bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5"
                        @input="validateMaintenanceInput"
                        @focus="onFocusMaintenanceInput"
                        @blur="onBlurMaintenanceInput"
                      />          
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Columna derecha vacía -->
            <div></div>
          </div>
          <hr class="h-px my-8 bg-gray-300 border-0">
          <!-- Tercera fila: Commission sections -->
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <!--Share commission sale section-->
            <div class="flex flex-col w-full space-y-8">
              <div class="flex flex-col w-full">
                <p class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">
                  Compartes comisión de venta
                </p>
                <div class="flex w-full space-x-4">
                  <div class="flex items-center">
                    <input
                      type="radio"
                      v-model="share_commission"
                      value="true"
                      id="share_commission_yes_v3"
                      name="share_commission_v3"
                      class="w-4 h-4 text-tuin-100 bg-gray-100 border-gray-300 focus:ring-transparent focus:ring-0"
                    >
                    <label for="share_commission_yes_v3" class="ms-2 text-sm font-medium text-custom_gray cursor-pointer">Sí</label>
                  </div>
                  <div class="flex items-center">
                    <input
                      type="radio"
                      v-model="share_commission"
                      value="false"
                      id="share_commission_no_v3"
                      name="share_commission_v3"
                      class="w-4 h-4 text-tuin-100 bg-gray-100 border-gray-300 focus:ring-transparent focus:ring-0"
                    >
                    <label for="share_commission_no_v3" class="ms-2 text-sm font-medium text-custom_gray cursor-pointer">No</label>
                  </div>
                </div>
              </div>
              <!--Commission range sale section-->
              <div v-show="share_commission == 'true'" class="flex flex-col w-full mr-0 md:mr-10">
                <CommissionRange
                  label="Comisión por venta*"
                  v-model="commission_value"
                  :max="10"
                  :min="1"
                  range-label="Porcentaje sobre el valor total de la operación"
                  display-text="Porcentaje a compartir"
                />
              </div>
            </div>
            <!--Share commission rent section-->
            <div class="flex flex-col w-full space-y-8">
              <div class="flex flex-col w-full">
                <p class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">
                  Compartes comisión de renta
                </p>
                <div class="flex w-full space-x-4">
                  <div class="flex items-center">
                    <input
                      type="radio"
                      v-model="share_commission_rent"
                      value="true"
                      id="share_commission_rent_yes_v3"
                      name="share_commission_rent_v3"
                      class="w-4 h-4 text-tuin-100 bg-gray-100 border-gray-300 focus:ring-transparent focus:ring-0"
                    >
                    <label for="share_commission_rent_yes_v3" class="ms-2 text-sm font-medium text-custom_gray cursor-pointer">Sí</label>
                  </div>
                  <div class="flex items-center">
                    <input
                      type="radio"
                      v-model="share_commission_rent"
                      value="false"
                      id="share_commission_rent_no_v3"
                      name="share_commission_rent_v3"
                      class="w-4 h-4 text-tuin-100 bg-gray-100 border-gray-300 focus:ring-transparent focus:ring-0"
                    >
                    <label for="share_commission_rent_no_v3" class="ms-2 text-sm font-medium text-custom_gray cursor-pointer">No</label>
                  </div>
                </div>
              </div>
              <!--Commission range rent section-->
              <div v-show="share_commission_rent == 'true'" class="flex flex-col w-full mr-0 md:mr-10">
                <CommissionRange
                  label="Comisión por renta*"
                  v-model="commission_value_rent"
                  :max="100"
                  :min="1"
                  range-label="Porcentaje sobre el valor total de la operación"
                  display-text="Porcentaje a compartir"
                />
              </div>
            </div>
          </div>
          <hr v-show="showAdvisorsNotification" class="h-px my-8 bg-gray-300 border-0">
          <!-- Message notification section for type_movement_id == 3 -->
          <div class="flex flex-col w-full mt-10">
            <div v-show="showAdvisorsNotification" class="flex flex-col w-full mr-0 md:mr-10">
              <p class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">
                Recibir mensajes de asesores que buscan propiedades para clientes o conocidos (sin compromiso de compartir comisión).
              </p>
              <div class="flex w-full space-x-4">
                <div class="flex items-center">
                  <input
                    type="radio"
                    v-model="advisorsNotification"
                    value="true"
                    id="advisors_notification_yes_v3"
                    name="advisors_notification_v3"
                    class="w-4 h-4 text-tuin-100 bg-gray-100 border-gray-300 focus:ring-transparent focus:ring-0"
                  >
                  <label for="advisors_notification_yes_v3" class="ms-2 text-sm font-medium text-custom_gray cursor-pointer">Sí</label>
                </div>
                <div class="flex items-center">
                  <input
                    type="radio"
                    v-model="advisorsNotification"
                    value="false"
                    id="advisors_notification_no_v3"
                    name="advisors_notification_v3"
                    class="w-4 h-4 text-tuin-100 bg-gray-100 border-gray-300 focus:ring-transparent focus:ring-0"
                  >
                  <label for="advisors_notification_no_v3" class="ms-2 text-sm font-medium text-custom_gray cursor-pointer">No</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Layout original para otros casos (no type_movement_id == 3) -->
        <template v-else>
          <!-- Price input sale section -->
          <div
            v-show="type_movement_id == 1 || type_movement_id == 5"
            class="flex flex-1 justify-center items-center"
          >
            <div class="w-full">
              <PriceInput
                label="Valor de venta *"
                v-model="property_value"
                :currency="currency"
                :currency-options="currencyOptions"
                input-id="currency-input"
                placeholder="Ingresa el precio de venta"
                :required="true"
                dropdown-align="right"
                @update:currency="selectCurrency"
              />
              <hr class="h-px my-8 bg-gray-300 border-0">
            </div>
          </div>
          <!-- Price input rent section-->
          <div
            v-show="type_movement_id == 2 || type_movement_id == 4"
            class="flex flex-1 justify-center items-center"
          >
            <div class="w-full">
              <PriceInput
                label="Valor de renta *"
                v-model="rent_value"
                :currency="rentCurrency"
                :currency-options="currencyOptions"
                input-id="rent-currency-input"
                placeholder="Ingresa el precio de renta"
                :required="true"
                dropdown-align="right"
                @update:currency="selectRentCurrency"
              />
              <hr class="h-px my-8 bg-gray-300 border-0">
            </div>
          </div>
        </template>
      </div>
      <!--Mantenance section-->
      <div
        v-if="type_movement_id != 3 && ![ 4, 6, 9 ].includes( type_property_id ) "
        class="flex flex-col space-y-8"
      >
        <div class="flex flex-1 justify-start items-start">
          <div class="flex flex-col w-full space-y-4">
            <div class="flex items-center">
              <input 
                id="include-maintenance-checkbox" 
                v-model="include_maintenance"
                type="checkbox" 
                class="w-4 h-4 text-tuin_base-0 bg-gray-100 border-gray-300 rounded focus:ring-transparent"
              >
              <label for="include-maintenance-checkbox" class="ms-2 text-sm font-medium text-custom_gray cursor-pointer">Incluye mantenimiento</label>
            </div>

            <div
              v-show="!include_maintenance "
              class="w-full"
            >
              <div class="w-full mt-[-1]">
                <p
                  class="block mb-2 text-sm font-medium text-custom_gray dark:text-white"
                >
                  Costo de mantenimiento *
                </p>
                <input
                  v-model="maintenance_value"
                  type="text"
                  id="maintenance_value"
                  placeholder="Ingresa el costo de mantenimiento"
                  class="bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5"
                  @input="validateMaintenanceInput"
                  @focus="onFocusMaintenanceInput"
                  @blur="onBlurMaintenanceInput"
                />          
              </div>
            </div>
          </div>
        </div>
        <hr class="h-px my-8 bg-gray-300 border-0">
      </div>

      <div 
        v-show="type_movement_id" 
        class="hidden flex-col w-full" 
      >
        <div class="bg-[#e99236] text-xs sm:text-base text-white p-5 ml-5 mr-5">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="float-left"
            width="25"
            height="25"
            viewBox="0 0 24 24"
          >
            <path
              fill="#fff"
              d="M12 2L1 21h22M12 6l7.53 13H4.47M11 10v4h2v-4m-2 6v2h2v-2"
            />
          </svg>
          <p class="float-left">
            Colabora con otros asesores para vender más rápido y recibir más
            clientes potenciales al compartir comisión.
          </p>
        </div>
      </div>
      <!--Share commission sale section-->
      <div 
        v-if="type_movement_id == 1" 
        class="flex flex-col w-full mt-8 space-y-8"
      >
        <div class="flex flex-col w-full">
          <p
            class="block mb-2 text-sm font-medium text-custom_gray dark:text-white"
          >
            Compartes comisión de venta
          </p>
          <div class="flex w-full space-x-4">
            <div class="flex items-center">
              <input
                type="radio"
                v-model="share_commission"
                value="true"
                id="share_commission_yes_v1"
                name="share_commission_v1"
                class="w-4 h-4 text-tuin-100 bg-gray-100 border-gray-300 focus:ring-transparent focus:ring-0"
              >
              <label for="share_commission_yes_v1" class="ms-2 text-sm font-medium text-custom_gray cursor-pointer">Sí</label>
            </div>
            <div class="flex items-center">
              <input
                type="radio"
                v-model="share_commission"
                value="false"
                id="share_commission_no_v1"
                name="share_commission_v1"
                class="w-4 h-4 text-tuin-100 bg-gray-100 border-gray-300 focus:ring-transparent focus:ring-0"
              >
              <label for="share_commission_no_v1" class="ms-2 text-sm font-medium text-custom_gray cursor-pointer">No</label>
            </div>
          </div>
        </div>
        <!--Commission range sale section-->
        <div 
          v-show="share_commission == 'true' " 
          class="flex flex-col w-full mr-0 md:mr-10"
        >
          <CommissionRange
            label="Comisión por venta*"
            v-model="commission_value"
            :max="10"
            :min="1"
            range-label="Porcentaje sobre el valor total de la operación"
            display-text="Porcentaje a compartir"
          />
        </div>
        <hr v-show="showAdvisorsNotification" class="h-px my-8 bg-gray-300 border-0">
      </div>
      <!--Share commission rent section-->
      <div 
        v-show="type_movement_id == 2" 
        class="flex flex-col w-full mt-8 space-y-8"
      >
        <div class="flex flex-col w-full">
          <p
            class="block mb-2 text-sm font-medium text-custom_gray dark:text-white"
          >
            Compartes comisión de renta
          </p>
          <div class="flex w-full space-x-4">
            <div class="flex items-center">
              <input
              type="radio"
              v-model="share_commission_rent"
              value="true"
              id="share_commission_rent_yes_v2"
              name="share_commission_rent_v2"
              class="w-4 h-4 text-tuin-100 bg-gray-100 border-gray-300 focus:ring-transparent focus:ring-0"
              >
              <label for="share_commission_rent_yes_v2" class="ms-2 text-sm font-medium text-custom_gray cursor-pointer">Sí</label>
            </div>
            <div class="flex items-center">
              <input
                type="radio"
                v-model="share_commission_rent"
                value="false"
                id="share_commission_rent_no_v2"
                name="share_commission_rent_v2"
                class="w-4 h-4 text-tuin-100 bg-gray-100 border-gray-300 focus:ring-transparent focus:ring-0"
              >
              <label for="share_commission_rent_no_v2" class="ms-2 text-sm font-medium text-custom_gray cursor-pointer">No</label>
            </div>
          </div>
        </div>
        <!--Commission range rent section-->
        <div 
          v-show="share_commission_rent == 'true' " 
          class="flex flex-col w-full mr-0 md:mr-10"
        >
          <CommissionRange
            label="Comisión por renta*"
            v-model="commission_value_rent"
            :max="100"
            :min="1"
            range-label="Porcentaje sobre el valor total de la operación"
            display-text="Porcentaje a compartir"
          />
        </div>
        <hr v-show="showAdvisorsNotification" class="h-px my-8 bg-gray-300 border-0">
      </div>
      <!--Message notification section-->
      <div v-if="type_movement_id == 1 || type_movement_id == 2" class="flex flex-col w-full mt-8">
        <div v-show="showAdvisorsNotification" class="flex flex-col w-full mr-0 md:mr-10">
          <p class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">
            Recibir mensajes de asesores que buscan propiedades para clientes o conocidos (sin compromiso de compartir comisión).
          </p>
          <div class="flex w-full space-x-4">
            <div class="flex items-center">
              <input
                type="radio"
                v-model="advisorsNotification"
                value="true"
                id="advisors_notification_yes"
                name="advisors_notification"
                class="w-4 h-4 text-tuin-100 bg-gray-100 border-gray-300 focus:ring-transparent focus:ring-0"
              >
              <label for="advisors_notification_yes" class="ms-2 text-sm font-medium text-custom_gray cursor-pointer">Sí</label>
            </div>
            <div class="flex items-center">
              <input
                type="radio"
                v-model="advisorsNotification"
                value="false"
                id="advisors_notification_no"
                name="advisors_notification"
                class="w-4 h-4 text-tuin-100 bg-gray-100 border-gray-300 focus:ring-transparent focus:ring-0"
              >
              <label for="advisors_notification_no" class="ms-2 text-sm font-medium text-custom_gray cursor-pointer">No</label>
            </div>
          </div>
        </div>
      </div>
      <!-- Fin del bloque precio -->
      <div class="mt-6 hidden flex-col-1 justify-end items-end">
        <button
          class="w-full sm:w-auto bg-tuin-100 text-white py-2.5 px-5 rounded-lg hover:bg-tuin_hover text-sm font-medium transition-colors"
          @click="save()"
        >
          Siguiente
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import ToastAlert from "@/commond/ToastAlert.vue";
import PriceInput from "@/components/common/PriceInput.vue";
import CommissionRange from "@/components/common/CommissionRange.vue";
import axios from "axios";
import LoaderTuin from "@/commond/LoaderTuin.vue";
import { ref, onMounted, computed, watch, defineEmits } from "vue";
import { useRouter } from "vue-router";
import { useRoute } from 'vue-router';
import { useStore } from "vuex";

const props = defineProps({
  resp: {
    type: Object,
    required: true,
    default: () => ({})
  },
  propertyId: {
    type: Number,
    required: true,
    default: 0
  },
  isAvailable: {
    type: Boolean,
    default: false
  }
});

const router = useRouter();
const route = useRoute();
const store = useStore();

const session = computed(() => store.getters.getUserSession);
const emit = defineEmits(['triggerUpdate']);

// Reactive variables for price-related data
const type_movement_id = ref(1);
const type_property_id = ref("");
const property_value = ref("");
const rent_value = ref("");
const include_maintenance = ref(false);
const maintenance_value = ref("");
const advisorsNotification = ref('false');

const share_commission = ref('true');
const commission_value = ref();

const share_commission_rent = ref('true');
const commission_value_rent = ref();

// Toast variables
const toastAlert = ref(false);
const typeMsg = ref("");
const msg = ref("");

// Currency variables
const currency = ref(null);
const currencyOptions = ref([]);
const showCurrencyDropdown = ref(false);
const rentCurrency = ref(null);
const showRentCurrencyDropdown = ref(false);

const resp_property_id = ref(0);

const showAdvisorsNotification = computed(() => {
  if (type_movement_id.value === 1) return share_commission.value === 'false';
  if (type_movement_id.value === 2) return share_commission_rent.value === 'false';
  if (type_movement_id.value === 3) return share_commission.value === 'false' && share_commission_rent.value === 'false';
  return false;
});

let loader = ref(false);

// Maintenance formatting (based on PriceInput component)
const formattedMaintenanceValue = ref('');

// Number formatting functions (basado en PriceInput)
const formatNumber = (value) => {
  if (!value) return '';
  
  // Remove any existing commas and non-numeric characters except dots
  const numericValue = value.toString().replace(/[^\d.]/g, '');
  
  // Parse as float to handle decimals
  const num = parseFloat(numericValue);
  
  if (isNaN(num)) return '';
  
  // Format with commas and preserve up to 2 decimal places
  return num.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
};

// Functions
function validateMaintenanceInput(event) {
  const value = event.target.value;
  
  // Remove any non-numeric characters except dots and commas
  let cleanValue = value.replace(/[^\d.,]/g, '');
  
  // Remove existing commas for processing
  cleanValue = cleanValue.replace(/,/g, '');
  
  // Limit to 2 decimal places
  const parts = cleanValue.split('.');
  if (parts.length > 2) {
    cleanValue = parts[0] + '.' + parts[1];
  }
  if (parts[1] && parts[1].length > 2) {
    cleanValue = parts[0] + '.' + parts[1].substring(0, 2);
  }
  
  // Update the formatted display value
  formattedMaintenanceValue.value = formatNumber(cleanValue);
  
  // Update the input field with formatted value
  event.target.value = formattedMaintenanceValue.value;
  
  // Store the clean numeric value
  const numericValue = parseFloat(cleanValue) || '';
  maintenance_value.value = numericValue.toString();
}

function onFocusMaintenanceInput(event) {
  // Show raw number when focused for easier editing
  event.target.value = maintenance_value.value ? maintenance_value.value.toString() : '';
}

function onBlurMaintenanceInput(event) {
  // Format with commas when user leaves the field
  const formatted = formatNumber(maintenance_value.value);
  formattedMaintenanceValue.value = formatted;
  event.target.value = formatted;
}

function selectCurrency(selectedCurrency) {
  currency.value = selectedCurrency;
  showCurrencyDropdown.value = false;
  
  // Si type_movement_id es 3, sincronizar con la moneda de renta
  if (type_movement_id.value === 3) {
    rentCurrency.value = selectedCurrency;
  }
}

function selectRentCurrency(selectedCurrency) {
  rentCurrency.value = selectedCurrency;
  showRentCurrencyDropdown.value = false;
  
  // Si type_movement_id es 3, sincronizar con la moneda de venta
  if (type_movement_id.value === 3) {
    currency.value = selectedCurrency;
  }
}

async function save() {
  let validation = await validate_form();
  if (!validation.status) {
    showToast("danger", validation.message);
    return;
  }

  // Update commission variables according to rules
  /*if (type_movement_id.value === 1 || type_movement_id.value === 3) {
    share_commission.value = (commission_value.value > 0) ? 'true' : 'false';
  }
  if (type_movement_id.value === 2 || type_movement_id.value === 3) {
    share_commission_rent.value = (commission_value_rent.value > 0) ? 'true' : 'false';
  }*/

  let post_params = {
    property_value: property_value.value,
    rent_value: rent_value.value,
    include_maintenance: include_maintenance.value,
    maintenance_value: maintenance_value.value,
    currency: currency.value?.name || rentCurrency.value?.name || "",
    currency_code: currency.value?.code || rentCurrency.value?.code || "",
    share_commission: share_commission.value,
    commission_value: commission_value.value,
    share_commission_rent: share_commission_rent.value,
    commission_value_rent: commission_value_rent.value,
    broker_id: session.value.id,
    receive_messages: advisorsNotification.value,
    type_movement_id: type_movement_id.value
  };

  let isUpdating = false;

  if (props.propertyId != 0) {
    post_params["property_id"] = props.propertyId;
    isUpdating = true;
  }

  if (resp_property_id.value != 0) {
    post_params["property_id"] = resp_property_id.value;
    isUpdating = true;
  }

  let url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${session.value.id}/save_info_price`;

  let options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.post(url, post_params, options);

    if (response.status === 200) {
      showToast("success", response.data.message);
      let updatedPropertyId = response.data.resp.id;
      emit("triggerUpdate", updatedPropertyId);

      // If updating, sync with external services
      if (isUpdating && props.isAvailable) {
        await syncWithPropiedades(updatedPropertyId);
        await syncWithEasyBroker(updatedPropertyId);
      }
      return true;
    } else {
      console.log("Error en la respuesta: ", response.status);
      return false;
    }
  } catch (error) {
    console.log("Error en la solicitud:", error);
    if (error.response && error.response.status === 401) {
      store.dispatch("clearUserSession");
      router.push({ name: "login" });
    }
    return false;
  }
}

async function syncWithPropiedades(propertyId) {
  let syncUrl = `${process.env.VUE_APP_API_BASE_URL}/propertiesComUpdate/${propertyId}`;

  let syncOptions = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const syncResponse = await axios.put(syncUrl, {}, syncOptions);
    if (syncResponse.status === 200) {
      console.log("success", "Propiedad sincronizada con propiedades.com");
    } else {
      console.log("Error en sincronización: ", syncResponse.status);
    }
  } catch (error) {
    console.log("Error en sincronización:", error);
  }
}

async function syncWithEasyBroker(propertyId) {
  let url_sync = `${process.env.VUE_APP_API_BASE_URL}/editar-easybroker/${propertyId}`;

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.post(url_sync, {}, options);

    if (
      response.status === 200 &&
      Array.isArray(response.data) &&
      response.data[0]?.status === "success"
    ) {
      console.log("[SYNC SUCCESS]", response.data);
      showToast("success", "Propiedad sincronizada con EasyBroker");
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      console.warn("[SYNC WARNING] Error en respuesta:", response.data);
    }

  } catch (error) {
    console.error("[ERROR SYNCING WITH EASYBROKER]", error.response);
    showToast("error", "Error al sincronizar con EasyBroker");
  }
}

async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}

async function showToast(type, message){
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;

  setTimeout(() => {
    closeToast()
  }, 3000);
}

async function validate_form() {
  if(type_movement_id.value == 1 || type_movement_id.value == 3){
    if(property_value.value  == undefined || property_value.value  == ''){
      return { "status": false, "message": "El campo valor de venta es obligatorio."}    
    }     
  }

  if(!currency.value && !rentCurrency.value) {
    return { "status": false, "message": "El campo tipo de moneda es obligatorio."};
  }

  if(type_movement_id.value == 2 || type_movement_id.value == 3){
    if(rent_value.value  == undefined || rent_value.value  == ''){
      return { "status": false, "message": "El campo valor de renta es obligatorio."}    
    }     
  }

  return { "status": true, "message": "Todo esta bien "}    
}

async function getCurrencies() {
  let url = `${process.env.VUE_APP_API_BASE_URL}/catalogue/type_currencies`;
  let options = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.get(url, options);

    if (response.status == 401) {
      store.dispatch("clearUserSession");
    }

    if (response.status == 200) {
      currencyOptions.value = response.data.resp.map(currency => ({
        code: currency.code,
        name: `${currency.name} (${currency.code})`
      }));

      // Set initial currency value if data exists
      if (props.resp && props.resp.general && props.resp.general.currency) {
        const foundCurrency = currencyOptions.value.find(
          c => c.name.includes(props.resp.general.currency)
        );
        if (foundCurrency) {
          currency.value = foundCurrency;
          rentCurrency.value = foundCurrency;
        }
      } else {
        // Set MXN as default if no currency is specified
        const defaultCurrency = currencyOptions.value.find(c => c.code === 'MXN');
        if (defaultCurrency) {
          currency.value = defaultCurrency;
          rentCurrency.value = defaultCurrency;
        }
      }
    }
  } catch (error) {
    console.error('Error al cargar las monedas:', error);
  }
}

onMounted(async () => {
  loader.value = true;
  await getCurrencies();
  loader.value = false;
  // Close dropdown when clicking outside
  document.addEventListener('click', (event) => {
    const dropdown = document.getElementById('dropdown-currency');
    const button = document.getElementById('dropdown-currency-button');
    const rentDropdown = document.getElementById('dropdown-rent-currency');
    const rentButton = document.getElementById('dropdown-rent-currency-button');
    
    if (dropdown && button && !dropdown.contains(event.target) && !button.contains(event.target)) {
      showCurrencyDropdown.value = false;
    }
    
    if (rentDropdown && rentButton && !rentDropdown.contains(event.target) && !rentButton.contains(event.target)) {
      showRentCurrencyDropdown.value = false;
    }
  });

  const input_sale = document.getElementById('property_value')
  if (input_sale) {
    input_sale.className = 'w-full pt-[-10px] bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 p-2.5 text-sm'
  }

  const input_rent = document.getElementById('rent_value')
  if (input_rent) {
    input_rent.className = 'w-full pt-[-10px] bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 p-2.5 text-sm'
  }

  const input_maintenance_value = document.getElementById('maintenance_value')
  if (input_maintenance_value) {
    input_maintenance_value.className = 'bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5'
    // Initialize formatted value if there's existing data
    if (maintenance_value.value) {
      formattedMaintenanceValue.value = formatNumber(maintenance_value.value);
      input_maintenance_value.value = formattedMaintenanceValue.value;
    }
  }
});

watch(
  () => props.resp,
  (newVal) => {
    if (newVal && newVal.general) {
      type_movement_id.value = newVal.general.type_movement_id || 1;
      type_property_id.value = newVal.general.type_property_id || "";
      property_value.value = newVal.general.property_value || "";
      rent_value.value = newVal.general.rent_value || "";
      include_maintenance.value = newVal.general.include_maintenance == 1 ? true : false;
      maintenance_value.value = newVal.general.maintenance_value || "";
      
      // Format maintenance value and update input field
      if (maintenance_value.value) {
        formattedMaintenanceValue.value = formatNumber(maintenance_value.value);
        setTimeout(() => {
          const input_maintenance = document.getElementById('maintenance_value');
          if (input_maintenance) {
            input_maintenance.value = formattedMaintenanceValue.value;
          }
        }, 100);
      }
      
      // Currency handling
      if (newVal.general.currency && currencyOptions.value.length > 0) {
        const foundCurrency = currencyOptions.value.find(
          c => c.name.includes(newVal.general.currency)
        );
        if (foundCurrency) {
          currency.value = foundCurrency;
          rentCurrency.value = foundCurrency;
        }
      }
      
      share_commission.value = newVal.general.has_commission_sale == 1 ? 'true' : 'false';
      advisorsNotification.value = newVal.general.advisorsNotification == 1 ? 'true' : 'false';
      commission_value.value = newVal.general.commission_sale_value !== undefined ? newVal.general.commission_sale_value : 1;
      share_commission_rent.value = newVal.general.has_commission_rent == 1 ? 'true' : 'false';
      commission_value_rent.value = newVal.general.commission_rent_value !== undefined ? newVal.general.commission_rent_value : 1;
    }
  },
  { immediate: true }
);

watch(
  () => route.params.id,
  (newId) => {
    if (newId) {
      resp_property_id.value = parseInt(newId);
    }
  },
  { immediate: true }
);

// Exponer el método save para que pueda ser llamado desde el componente padre
defineExpose({
  save
});
</script>

<style scoped>
/* Personalización de VueDatePicker con colores tuin-100 */
:deep(.dp__theme_light) {
    --dp-background-color: #fff;
    --dp-text-color: #737373;
    --dp-hover-color: #f3f3f3;
    --dp-hover-text-color: #737373;
    --dp-hover-icon-color: #737373;
    --dp-primary-color: #FF4265;
    --dp-primary-disabled-color: #6bacea;
    --dp-primary-text-color: #f8f5f5;
    --dp-secondary-color: #c0c4cc;
    --dp-border-color: #ddd;
    --dp-menu-border-color: #ddd;
    --dp-border-color-hover: #FF4265;
    --dp-border-color-focus: #FF4265;
    --dp-disabled-color: #f6f6f6;
    --dp-scroll-bar-background: #f3f3f3;
    --dp-scroll-bar-color: #737373;
    --dp-success-color: #76d275;
    --dp-success-color-disabled: #a3d9b1;
    --dp-icon-color: #737373;
    --dp-danger-color: #ff6f60;
    --dp-marker-color: #ff6f60;
    --dp-tooltip-color: #fafafa;
    --dp-disabled-color-text: #8e8e8e;
    --dp-highlight-color: rgb(25, 118, 210);
    --dp-range-between-dates-background-color: var(--dp-hover-color, #f3f3f3);
    --dp-range-between-dates-text-color: var(--dp-hover-text-color, #212121);
    --dp-range-between-border-color: var(--dp-hover-color, #f3f3f3);
    --dp-input-padding: 9px 42px 9px 16px;
    --dp-border-radius: 8px;
}
</style>